"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSonarObjectsOptimisticChangeState = void 0;
exports.defaultSonarObjectsOptimisticChangeState = { data: {
        salesforce: {},
        sonarObjectIds: {}
    } };
//# sourceMappingURL=state.js.map